import React from 'react'
import { v, Water, SunRoad, Swells } from './shared'

// An alpine lake in the Sierra: granite peaks in the haze, a ridge of pines
// along the far shore, the lake carrying the sun's road, mist lying on the
// water, and a sandy near shore.

// A pine is three stacked triangles; the union reads as a tree at any size.
const pine = (x, base, h, w) => {
  const p = (nx, ny) => `${(+nx).toFixed(1)},${(+ny).toFixed(1)}`
  const top = base - h
  const t2 = base - h * 0.64
  const t3 = base - h * 0.34
  return [
    `M${p(x, top)} L${p(x + w * 0.24, t2)} L${p(x - w * 0.24, t2)} Z`,
    `M${p(x, base - h * 0.82)} L${p(x + w * 0.38, t3)} L${p(x - w * 0.38, t3)} Z`,
    `M${p(x, base - h * 0.56)} L${p(x + w * 0.5, base)} L${p(x - w * 0.5, base)} Z`,
  ].join(' ')
}

// Treeline along the far shore, varied deterministically.
const TREELINE = (() => {
  let seed = 19970614
  const rnd = () => { seed = (seed * 1664525 + 1013904223) % 4294967296; return seed / 4294967296 }
  const d = []
  for (let x = -6; x < 812; x += 9 + rnd() * 5) {
    const h = 12 + rnd() * 16
    d.push(pine(x, 301, h, 7 + h * 0.34))
  }
  return d.join(' ')
})()


const Forest = ({ variant }) => (
  <>
    {/* Granite peaks, far back in the haze */}
    <path
      d="M-10,300 L40,262 L80,278 L130,240 L170,266 L215,232 L260,262 L300,248 L350,280 L400,256 L450,284 L500,250 L545,272 L600,236 L650,266 L700,246 L750,272 L810,258 V300 Z"
      className="silhouette-far"
    />
    <path
      d="M-10,300 L30,286 L90,292 L140,270 L190,288 L240,276 L290,294 L340,282 L380,300 Z M430,300 L470,290 L520,296 L570,278 L620,292 L680,284 L740,296 L810,286 V300 Z"
      className="silhouette-mid"
    />

    {/* The ridge of pines along the far shore */}
    <g className="silhouette-near">
      <rect x="0" y="296" width="800" height="6" />
      <path d={TREELINE} />
    </g>

    <Water />

    {/* Mist lying on the lake, drifting like the clouds */}
    <g className="cloud" style={{ animationDuration: '96s', animationDelay: '-40s' }}>
      <ellipse cx="400" cy="322" rx="290" ry="9" style={{ fill: v('cloud3') }} opacity="0.22" />
      <ellipse cx="560" cy="334" rx="180" ry="6" style={{ fill: v('cloud2') }} opacity="0.16" />
    </g>

    <SunRoad />
    <Swells />

    {variant !== 'band' && (
      /* The near shore, sand down to the water. */
      <path d="M0,436 C120,430 260,441 400,434 C540,427 660,439 800,432 L800,500 L0,500 Z" fill="url(#sky-sand)" />
    )}
  </>
)

Forest.label = 'The sun over an alpine lake in the Sierra, drawn to match the time of day.'

export default Forest
